import endpoints from "@/utils/constants";
import { apiHelper, authHelper } from "@/utils/helpers";
import serviceRequestProduct from "@/utils/ServiceRequestProductsUtil";
const actions = {
  saveServiceRequestChalan(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/chalans`,
          context.state.serviceRequestChalan
        )
        .then(res => {
          if (res.status === 201) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getServiceRequestChalans(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload}/chalans`
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setServiceRequestChalansList", res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getAllChalans(context, query) {
    const url = new URL(
      `${endpoints.BASE_URL}/api/v1/service-request-chalans/`
    );
    if (query) {
      url.search = new URLSearchParams(query);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            context.commit("setAllChalansList", res.data);
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getInwardProductsForServiceRequest(_, serviceRequestId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/service-requests/${serviceRequestId}/inward-products`
        )
        .then(res => {
          console.log(res);
          if (res.status === 200) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getServiceRequestChalanDetails(context, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}/api/v1/service-request-chalans/${payload}`
        )
        .then(response => {
          if (response.status === 201) {
            context.commit("setChalan", response.data);
            resolve(response.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateServiceRequestChalanItem(_, item) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "patch",
          `${endpoints.BASE_URL}/api/v1/service-request-chalans/chalan-items/${item.serviceRequestChalanItemId}`,
          item
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  //using in service request chalan details file so not using
  updateServiceRequestChalan(context) {
    if (context.state.serviceRequestChalan.createdBy === "") {
      delete context.state.serviceRequestChalan.createdBy;
    }
    delete context.state.serviceRequestChalan.chalanNumber;
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "put",
          `${endpoints.BASE_URL}/api/v1/service-request-chalans/${context.state.serviceRequestChalan.serviceRequestChalanId}`,
          context.state.serviceRequestChalan
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateServiceRequestChalanData(_, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "patch",
          `${endpoints.BASE_URL}/api/v1/service-request-chalans/${payload.serviceRequestChalanId}/data`,
          payload
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveChalanFromPos(_, payload) {
    return new Promise((resolve, reject) => {
      const isUUID = value =>
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
          String(value || "")
        );

      if (!isUUID(payload.serviceRequestId)) {
        reject(new Error("Service request is required to save a chalan."));
        return;
      }

      if (!payload.chalanItems || payload.chalanItems.length === 0) {
        reject(new Error("At least one product is required to save a chalan."));
        return;
      }

      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.serviceRequests}/${payload.serviceRequestId}/chalans`,
          payload
        )
        .then(res => {
          if (res.status === 201) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  // print chalan
  printChalan(_, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.PRINTER_API_URL}${endpoints.PRINT_API.chalan}`,
          payload
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default actions;
